export const environment = {
  production: false,
  apiUrl: 'https://parking-hub.dev.processway.pl/api',
  keycloakUrl: 'https://idp.dev.processway.pl',
  keycloakClientId: '5ff199f3-ca6a-4c94-8084-f15dbf77b4e3',
  keycloakScope: 'parking_hub profile roles',
  realm: 'core'
};
